module.exports = __webpack_public_path__ + "static/img/icon-01.fddcada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/reason/icon-01.png
// module id = eaZ/
// module chunks = 1